<app-modal #modal>

  <span title>{{""|translate}}</span>

  <div body id="carouselExample" class="carousel slide">
    <div class="carousel-inner">
      @for (media of mediaList(); track $index) {
      <div class="carousel-item" [class.active]="selectedMedia() === media">
        <img [src]="media" class="d-block h-100">
      </div>
      }
    </div>
    @if(mediaList().length > 1) {
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
    }
  </div>

  <div footer class="footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}
    </button>
  </div>

</app-modal>
